<template>
  <span class="form-icons" :class="{ 'justify-between': icon && !focused }">
    <slot name="icon" v-if="icon && !focused">
      <span class="form-icon icon" :class="[getIcon, iconClasses]"></span>
    </slot>
    <div :class="{ 'pointer-events-auto': !disableAction }" v-if="$slots.action">
      <slot name="action"></slot>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    icon: String,
    iconClasses: {
      type: [String, Array],
      default: 'text-gray-700'
    },
    focused: {
      type: Boolean,
      default: false
    },
    disableAction: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getIcon() {
      return `icon-${this.icon}`
    },
  }
}
</script>